var map = {
	"./flow/announcement/v1/index.js": 25235,
	"./flow/announcement/v1_001/index.js": 24423,
	"./flow/announcement/v1_HK02498/index.js": 83804,
	"./flow/announcement/v1_HK06168/index.js": 86653,
	"./flow/announcement/v1_SH601168/index.js": 1893,
	"./flow/announcement/v1_SH688050/index.js": 33387,
	"./flow/announcement/v1_SZ002379/index.js": 40190,
	"./flow/announcement/v1_SZ300687/index.js": 92053,
	"./flow/corporate_governance/v1/index.js": 38113,
	"./flow/corporate_governance/v1_HK02498/index.js": 89879,
	"./flow/custom/v1/index.js": 70720,
	"./flow/custom/v1_HK06168/index.js": 35426,
	"./flow/customs_calendar/v1/index.js": 55552,
	"./flow/esg/v1/index.js": 46001,
	"./flow/finance_data/v1/index.js": 6646,
	"./flow/finance_data/v1_SH601168/index.js": 74223,
	"./flow/investment_activity/v1/index.js": 50383,
	"./flow/investment_activity/v1_001/index.js": 17707,
	"./flow/investment_activity/v1_SZ002379/index.js": 47462,
	"./flow/investment_activity/v1_SZ300687/index.js": 36177,
	"./flow/news/v1/index.js": 82147,
	"./flow/performance_report/v1/index.js": 79833,
	"./flow/performance_report/v1_HK02498/index.js": 70094,
	"./flow/performance_report/v1_HK06168/index.js": 79844,
	"./flow/quarterly_performance/v1/index.js": 5995,
	"./flow/quarterly_performance/v1_SZ002379/index.js": 10945,
	"./flow/question/v1/index.js": 94018,
	"./flow/question/v1_001/index.js": 91058,
	"./flow/question/v1_SH601168/index.js": 15411,
	"./flow/question/v1_SH603129/index.js": 96408,
	"./flow/question/v1_SH688050/index.js": 94095,
	"./flow/question/v1_SZ002379/index.js": 44629,
	"./flow/quote/v1/index.js": 79870,
	"./flow/quote/v1_001/index.js": 35496,
	"./flow/quote/v1_SH601168/index.js": 37355,
	"./flow/quote/v1_SH688050/index.js": 47299,
	"./flow/quote/v1_SZ002379/index.js": 99530,
	"./flow/quote/v1_SZ002685/index.js": 20537,
	"./flow/report/v1/index.js": 27987,
	"./flow/us_announcement/v1/index.js": 76807,
	"./flow/widget_shell/v1/index.js": 61161,
	"./flowX/analyst/v1_HK09606/index.js": 46515,
	"./flowX/announcement/v1/index.js": 27133,
	"./flowX/announcement/v1_SZ000157/index.js": 25044,
	"./flowX/announcement/v1_SZ003010/index.js": 36084,
	"./flowX/announcement/v1_SZ300687/index.js": 76275,
	"./flowX/contact_information/v1_SZ003010/index.js": 95117,
	"./flowX/contact_information_diagens/v1_diagens/index.js": 46177,
	"./flowX/contact_information_hk09606/v1/index.js": 45396,
	"./flowX/corporate_governance/v1_SH600519/index.js": 88881,
	"./flowX/corporate_governance/v1_SZ000157/index.js": 58643,
	"./flowX/corporate_governance/v1_SZ003010/index.js": 97670,
	"./flowX/corporate_governance/v1_diagens/index.js": 34742,
	"./flowX/corporate_governance_hk09606/v1/index.js": 92550,
	"./flowX/custom/v1/index.js": 95671,
	"./flowX/customs_calendar/v1/index.js": 25002,
	"./flowX/esg/v1/index.js": 51103,
	"./flowX/finance_data/v1/index.js": 84313,
	"./flowX/finance_data_sz003010/v1_SZ003010/index.js": 70182,
	"./flowX/hk_announcement/v1_SZ000157/index.js": 92903,
	"./flowX/hk_announcement/v1_SZ003010/index.js": 98160,
	"./flowX/hk_report/v1_SZ000157/index.js": 56096,
	"./flowX/information_disclosure/v1_diagens/index.js": 34274,
	"./flowX/investment_activity/v1/index.js": 69225,
	"./flowX/investment_activity/v1_HK09606/index.js": 40027,
	"./flowX/investment_activity/v1_SZ003010/index.js": 23744,
	"./flowX/news/v1/index.js": 46921,
	"./flowX/performance_report/v1/index.js": 57995,
	"./flowX/performance_report/v1_HK02498/index.js": 12708,
	"./flowX/quarterly_performance/v1/index.js": 7330,
	"./flowX/quarterly_performance/v1_SZ000157/index.js": 99638,
	"./flowX/question/v1/index.js": 37480,
	"./flowX/question/v1_SZ000157/index.js": 59188,
	"./flowX/quote/v1/index.js": 12174,
	"./flowX/quote/v1_HK09606/index.js": 35122,
	"./flowX/quote/v1_SZ000157/index.js": 96949,
	"./flowX/quote/v1_SZ003010/index.js": 88517,
	"./flowX/report/v1/index.js": 29058,
	"./flowX/report/v1_HK09606/index.js": 26161,
	"./flowX/report/v1_SZ000157/index.js": 73402,
	"./flowX/report/v1_SZ003010/index.js": 8323,
	"./flowX/summary/v1_SZ003010/index.js": 75153,
	"./flowX/us_announcement/v1/index.js": 54623,
	"./flowX/widget_shell/v1/index.js": 30203,
	"./flowX/widget_shell/v1_SH600519/index.js": 32178,
	"./flowX/widget_shell/v1_diagens/index.js": 39442,
	"./slide/analyst/v1/index.js": 30530,
	"./slide/analyst/v1_HK02411/index.js": 67921,
	"./slide/announcement/v1/index.js": 39052,
	"./slide/announcement/v1_SH600008/index.js": 64765,
	"./slide/company_overview/v1/index.js": 51002,
	"./slide/company_overview/v1_HK06181/index.js": 76208,
	"./slide/contact_information/v1/index.js": 46924,
	"./slide/contact_information/v1_HK02411/index.js": 33429,
	"./slide/contact_information/v1_HK06181/index.js": 57328,
	"./slide/corporate_governance/v1/index.js": 84405,
	"./slide/corporate_governance_v2/v1/index.js": 52604,
	"./slide/custom/v1/index.js": 90693,
	"./slide/custom/v1_HK02411/index.js": 53276,
	"./slide/customs_calendar/v1/index.js": 68228,
	"./slide/dividend_plan/v1/index.js": 96282,
	"./slide/dividend_plan/v1_SZ002368/index.js": 24645,
	"./slide/esg/v1/index.js": 19240,
	"./slide/esg/v1_HK02411/index.js": 38616,
	"./slide/finance_data/v1/index.js": 62308,
	"./slide/fund_holding/v1/index.js": 47701,
	"./slide/main_business/v1/index.js": 87542,
	"./slide/news/v1/index.js": 18380,
	"./slide/performance_report/v1/index.js": 32182,
	"./slide/performance_report/v1_HK02498/index.js": 31921,
	"./slide/quarterly_performance/v1/index.js": 59235,
	"./slide/question/v1/index.js": 82263,
	"./slide/quote/v1/index.js": 46971,
	"./slide/quote/v1_SH600223/index.js": 92238,
	"./slide/quote/v1_SH601992/index.js": 20136,
	"./slide/quote/v1_SZ002368/index.js": 83701,
	"./slide/quote/v1_SZ002379/index.js": 50885,
	"./slide/report/v1/index.js": 92137,
	"./slide/report/v1_SZ002368/index.js": 16322,
	"./slide/shareholder_count/v1/index.js": 55365,
	"./slide/summary/v1_SZ002368/index.js": 73197,
	"./slide/top_ten_shareholder/v1/index.js": 99300,
	"./slide/us_announcement/v1/index.js": 28031,
	"./slide/widget_shell/v1/index.js": 12658,
	"./slideM/analyst/v1/index.js": 48160,
	"./slideM/announcement/v1/index.js": 60991,
	"./slideM/announcement/v1_HK06168/index.js": 55737,
	"./slideM/company_overview/v1/index.js": 5543,
	"./slideM/contact_information/v1/index.js": 36713,
	"./slideM/corporate_governance/v1/index.js": 70334,
	"./slideM/corporate_governance_v2/v1/index.js": 37673,
	"./slideM/custom/v1/index.js": 76975,
	"./slideM/customs_calendar/v1/index.js": 40678,
	"./slideM/dividend_plan/v1/index.js": 70939,
	"./slideM/esg/v1/index.js": 96261,
	"./slideM/finance_data/v1/index.js": 81951,
	"./slideM/fund_holding/v1/index.js": 15931,
	"./slideM/investment_activity/v1/index.js": 91357,
	"./slideM/main_business/v1/index.js": 71226,
	"./slideM/news/v1/index.js": 37571,
	"./slideM/performance_report/v1/index.js": 88309,
	"./slideM/quarterly_performance/v1/index.js": 19808,
	"./slideM/question/v1/index.js": 90922,
	"./slideM/quote/v1/index.js": 93514,
	"./slideM/report/v1/index.js": 63028,
	"./slideM/shareholder_count/v1/index.js": 19182,
	"./slideM/summary/v1/index.js": 78726,
	"./slideM/top_ten_shareholder/v1/index.js": 64957,
	"./slideM/us_announcement/v1/index.js": 25344,
	"./slideM/widget_shell/v1/index.js": 78493,
	"./surf/analyst/v1/index.js": 85134,
	"./surf/announcement/v1/index.js": 2409,
	"./surf/contact_information/v1/index.js": 78253,
	"./surf/corporate_governance/v1/index.js": 91478,
	"./surf/custom/v1/index.js": 92060,
	"./surf/customs_calendar/v1/index.js": 87852,
	"./surf/dividend_plan/v1/index.js": 2659,
	"./surf/finance_data/v1/index.js": 56655,
	"./surf/fund_holding/v1/index.js": 19855,
	"./surf/investment_activity/v1/index.js": 27788,
	"./surf/new_banner/v1/index.js": 12866,
	"./surf/news/v1/index.js": 81183,
	"./surf/performance_report/v1/index.js": 98002,
	"./surf/quarterly_performance/v1/index.js": 68213,
	"./surf/question/v1/index.js": 12777,
	"./surf/report/v1/index.js": 34408,
	"./surf/shareholder_count/v1/index.js": 72409,
	"./surf/summary/v1/index.js": 32630,
	"./surf/top_ten_shareholder/v1/index.js": 29870,
	"./surf/us_announcement/v1/index.js": 17676,
	"./surf/widget_shell/v1/index.js": 58632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53586;